import React from 'react';
import { Typography } from 'antd';
import { GradientHeader } from '../styles';

const { Title } = Typography;

const DashboardHeader = () => (
  <GradientHeader>
    <Title level={3} style={{ color: '#fff', margin: 0 }}>
      대시보드
    </Title>
  </GradientHeader>
);

export default DashboardHeader;
